import { Colors } from '../constants/colors';
import { GAME_HEIGHT, GAME_WIDTH } from '../constants/constants';
import { Scenes } from '../constants/scenes';

export function splashScene() {
  scene(Scenes.SPLASH, () => {
    debug.log('in splash scene');
    const title = add([
      text('amissus', { font: 'arial', size: 64, width: 600 }),
      color(...Colors.BLACK),
      pos(GAME_WIDTH / 2 - 128, GAME_HEIGHT / 2 - 50),
      opacity(1),
      // anchor('center'),
    ]);

    // background music now starts in main.ts so it plays regardless of skipping
    // scenes via cheats. We keep a reference here only for typing.

    wait(3, () => {
      // Fade out over 3 seconds using tween
      tween(
        1, // from opacity 1
        0, // to opacity 0
        2, // duration in seconds
        (val) => {
          title.opacity = val;
        },
        typeof easings !== 'undefined' && easings.linear ? easings.linear : undefined,
      );
      // Fallback: after 1s, destroy and go
      wait(1, () => {
        destroy(title);
        go(Scenes.CHARACTER_SELECTION);
      });
    });
  });
}
